import { render, staticRenderFns } from "./BreakdownCreated.vue?vue&type=template&id=396689fc&scoped=true&"
import script from "./BreakdownCreated.vue?vue&type=script&lang=js&"
export * from "./BreakdownCreated.vue?vue&type=script&lang=js&"
import style0 from "./BreakdownCreated.vue?vue&type=style&index=0&id=396689fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396689fc",
  null
  
)

export default component.exports